import { render, staticRenderFns } from "./editTestPaper.vue?vue&type=template&id=6897e9a4&scoped=true"
import script from "./editTestPaper.vue?vue&type=script&lang=js"
export * from "./editTestPaper.vue?vue&type=script&lang=js"
import style0 from "./editTestPaper.vue?vue&type=style&index=0&id=6897e9a4&prod&lang=less&scoped=true"
import style1 from "./editTestPaper.vue?vue&type=style&index=1&id=6897e9a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897e9a4",
  null
  
)

export default component.exports